import { render } from "./SellerContact.vue?vue&type=template&id=4c42a0dd"
import script from "./SellerContact.vue?vue&type=script&lang=js"
export * from "./SellerContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__